var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-inner-declarations */
import logger from '../../../utils/src/logger';
import types from './PropertyTypes';
export var prototypeAdditions;
(function (prototypeAdditions) {
    /**
     * Defines the internal properties hash.
     * Called on creation of the component.
     * @abstract
     * @return undefined
     */
    function __defineProperties() {
        this.__properties = {};
        for (var propertyName in this.__propertiesDefinition) {
            this.__setToDefault(propertyName);
        }
    }
    prototypeAdditions.__defineProperties = __defineProperties;
    function __setToDefault(propertyName) {
        var definition = this.__propertiesDefinition[propertyName];
        var type = types[definition.type];
        var defaultValue = type.getDefaultValue(definition);
        if (this[propertyName] !== defaultValue) {
            this[propertyName] = defaultValue;
        }
    }
    prototypeAdditions.__setToDefault = __setToDefault;
    function __setFromString(propertyName, newValue) {
        var definition = this.__propertiesDefinition[propertyName];
        var type = types[definition.type];
        // Only continue if we have an attribute -> property mapper
        // for this type.
        if (!type.fromAttribute) {
            return;
        }
        if (newValue === null) {
            this.__setToDefault(propertyName);
            return;
        }
        var propertyValue = type.fromAttribute(newValue, propertyName);
        // Syncing with properties if necessary.
        if (this[propertyName] !== propertyValue) {
            this[propertyName] = propertyValue;
        }
    }
    prototypeAdditions.__setFromString = __setFromString;
})(prototypeAdditions || (prototypeAdditions = {}));
/**
 * Adds properties to the given component.
 * Defines setter and getter methods for the provided list of properties.
 * The base setter is also calling the attribute setters, if defined.
 * @abstract
 */
export function extendComponent(customPrototype, definition) {
    definition.properties = definition.properties || {};
    var propertiesDefinition = definition.properties;
    customPrototype.__propertiesDefinition = propertiesDefinition;
    // add property definition for each declared region
    var regionNames = definition.regions ? Object.keys(definition.regions) : [];
    regionNames.forEach(function (regionName) {
        var regionDefinition = definition.regions[regionName];
        propertiesDefinition[regionName] = __assign({ type: 'region' }, regionDefinition);
    });
    var getGetter = function (propertyName) {
        return function () {
            return this.__properties[propertyName];
        };
    };
    var getSetter = function (propertyName) {
        var propertyDefinition = propertiesDefinition[propertyName];
        return function (newValue) {
            var oldValue = this[propertyName];
            var type = types[propertyDefinition.type];
            if (type.hasChanged(oldValue, newValue)) {
                type.validate(newValue, propertyName, propertyDefinition);
                this.__properties[propertyName] = newValue !== undefined ? newValue : type.getDefaultValue(propertyDefinition);
                notifyChange.call(this, propertyName, oldValue, newValue);
            }
        };
    };
    var notifyChange = function (propertyName, oldValue, newValue) {
        if (!this.__created) {
            return;
        }
        var propertyDefinition = propertiesDefinition[propertyName];
        if (typeof propertyDefinition.onChange === 'function') {
            propertyDefinition.onChange.call(this, oldValue, newValue);
        }
        __update.call(this, propertyDefinition, newValue);
        if (propertyDefinition.announceValue === true) {
            this.__firePropertyChangeEvent(propertyName);
        }
    };
    var __update = function (propertyDefinition, newValue) {
        // Component will be rerendered when attached
        if (this.__componentState === 'detached') {
            return;
        }
        if (propertyDefinition.type === 'region' && newValue) {
            this.__updateImmediately();
            return;
        }
        this.__update();
    };
    for (var propertyName in propertiesDefinition) {
        var propertyDefinition = propertiesDefinition[propertyName];
        propertyDefinition.type = propertyDefinition.type || 'string';
        var type = types[propertyDefinition.type];
        if (!type) {
            logger.error('No such type "' + propertyDefinition.type + '" for property ' + propertyName);
            continue;
        }
        Object.defineProperty(customPrototype, propertyName, {
            get: getGetter(propertyName),
            set: getSetter(propertyName)
        });
    }
}
//# sourceMappingURL=PropertyHandling.js.map